<ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px'}"></ngx-loading>
<div class="tourPopUp">
  <h2 mat-dialog-title>
    <div class="pull-right">
      <a class="boxclose" (click)="onNoClick(false)"></a>
    </div>
  </h2>
  <mat-dialog-content class="mat-typography">
    <div class="col-md-12">
      <h2 class="col-12 text-center"><b>Welcome to the TTN Fleet Solutions Client Portal</b></h2>
      <h4 class="col-12 text-center">This portal allows you to manage all aspects of yours relationship with TTN Fleet
        Solutions. This simple tutorial will show you how to navigate.</h4>
    </div>
    <div class="col-md-12 boxLinks">
      <a (click)="takeTour()"> Take a tour</a>
      <!-- <mat-checkbox class="pull-right" (click)="doNotShow($event)">Do Not Show Again</mat-checkbox> -->
    </div>
  </mat-dialog-content>
</div>